<template>
    <b-card>
        <!-- HEADER -->
        <template slot="header" v-if="title">

            <!-- TITLE -->
            <div class="card-title">
                <strong>{{ title }}</strong>
            </div>

            <!-- SEARCH INPUT -->
            <div class="card-options" v-if="controls.search">
                <!-- <div class="input-group"> -->
                    <!-- <div class="input-icon"> -->
                        <search-box
                            :list="itemsRef"
                            :filtered-list="filteredItems"
                            :fields="headerFields"
                            :lazy="isLazy"
                            />
                    <!-- </div> -->
                <!-- </div> -->
            </div>
        </template>
        <!-- END OF HEADER -->

        <!-- BODY -->
        <template slot="body">
            <!-- PRE-BODY -->
            <div class="card-body card-table-controls" v-if="hasBodyContent">
                <slot name="body"></slot>
            </div>

            <!-- TABLE -->
            <div class="table-responsive">
                <table
                    class="table card-table table-striped table-hover table-vcenter"
                    :class="hasSelectedItem ? 'has-selected-item' : ''">

                    <!-- TABLE HEADER -->
                    <thead v-if="headers">
                        <tr>
                            <th>#</th>
                            <th
                                v-for="(header, idx) in headers"
                                :key="idx">
                                {{ header.label }}
                                <sort-button
                                    v-if="controls.sort"
                                    :field="header.key"
                                    :list="itemsRef"
                                />
                            </th>
                            <th v-if="hasCellContent">&nbsp;</th>
                        </tr>
                    </thead>

                    <!-- TABLE BODY -->
                    <tbody v-if="paginatedItems">
                        <tr
                            v-for="(item, idx) in paginatedItems"
                            :class="isSelectedItem(item) ? 'selected-row' : ''"
                            :key="idx"
                            @click="selectItem(item)">

                            <td>{{ idx+1 }}</td>
                            <td
                            v-for="(value, key) in bodyValues(item)"
                            :key="key">
                            {{ value }}
                            </td>

                            <td v-if="hasCellContent">
                            <slot
                                name="cell"
                                :rowData="{ item, idx, itemIdx : _itemIndex(item) }" />
                            </td>

                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>Sorry, no entries.</tr>
                    </tbody>
                </table>
            </div>
        </template>
        <!-- END OF BODY -->

        <!-- FOOTER -->
        <template slot="footer">
            <div class="row mb-2">
                <div class="col-sm">
                    Showing {{ paginatedItems.length }} of {{ totalRecords }} records
                </div>

                <div class="col-sm">
                    <pagination
                        class=""
                        button-class=""
                        :list="filteredItems"
                        :filtered-list="paginatedItems"
                        :num-of-items="controls.itemsPerPage"/>
                </div>
            </div>

            <template v-if="hasFooterContent">
                <div class="row mb-2">
                    <div class="col-sm">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </template>
        </template>
        <!-- END OF FOOTER -->
    </b-card>
</template>

<script>
import TableComponents from '../mixins/TableComponentsMixin';
import OptionalSlots from '../mixins/OptionalSlotsMixin';
import Utils from '../mixins/ObjectUtilsMixin';

export default {
    mixins: [
        TableComponents,
        OptionalSlots,
        Utils,
    ],

    props: {
        title: {
            type: String,
            default: null,
        },
        controls: {
            type: Object,
            default: () => {
                return {
                    search: true,
                    sort: true,
                    itemsPerPage: 5,
                };
            },
        },

        lazyLimit: {
            type: Number,
            default: 20000,
        },

        headers: {
            type: Array,
            default: () => [],
        },
        items: {
            type: Array,
            default: () => [],
        },
        selectedItem: {
            type: Object,
            default: null,
        },
        foundItems: {
            // items filtered by "search" functionality of the table
            type: Array,
            default: () => [],
        },
    },

    data() {
        // copies
        // paginatedItems will be filled automatically from the filteredItems
        // let copyItems = this.items.slice();
        let itemsRef = this.items;
        let filteredItems = [];
        let paginatedItems = [];

        return {
            itemsRef,
            filteredItems,
            paginatedItems,
        };
    },

    computed: {
        headerFields() {
            if (!this.headers) {
                return [];
            }

            return this.headers.map(h => h.key);
        },
        totalRecords() {
            if (!this.items) {
                return 0;
            }

            return this.items.length;
        },
        hasSelectedItem() {
            return !!this.selectedItem;
        },

        isLazy()
        {
            if (this.items.length >= this.lazyLimit)
                return true;

            return false;
        }
    },

    watch: {
        filteredItems: {
            handler() {
                this.foundItems.splice(0, this.foundItems.length);
                this.filteredItems.forEach(x => this.foundItems.push(x));
            },
            deep: true,
        },
        items: {
            handler() {
                this.itemsRef = this.items;
            },
            deep: true,
        }
    },

    methods: {
        isSelectedItem(item) {
            let equalities = [];

            this.headerFields.forEach(key => {
                equalities.push(
                    this.dotGet(key, item) === this.dotGet(key, this.selectedItem)
                );
            });

            return equalities.every(eq => eq);
        },
        bodyValues(item) {
            let displayObj = {};

            // .reduce() fills displayObj with values
            this.headers
                .map(h => h.key)
                .reduce((obj, key) => {
                    obj[key] = this.dotGet(key, item);
                    return obj;
                }, displayObj);

            return displayObj;
        },
        selectItem(item) {
            this.$emit('item-selected', item);
        },

        _itemIndex(item)
        {
            return this.itemsRef.indexOf(item);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/table-components/CardTableComponent.vue